export const name = 'siteTopologyService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-topology' as const
